import { shallow } from 'zustand/shallow';
import { MultiSelectDropdown } from '@repo/ui/OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '@repo/ui/OffersFilter/useFilterEvents';
import { useOffersFilterStore } from '../store';
import { useRangeFilterOptions } from '../store/hooks';

export const MinDepositSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
  isFiltersInHeader,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
  isFiltersInHeader?: boolean;
}) => {
  const minDepositOptions = useRangeFilterOptions('minimumBalance');
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleMinDepositChange = (selectedLabels: string[]) => {
    if (scrollBackToMainBar) {
      scrollBackToMainBar();
    }

    setTimeout(
      () => {
        handleUpdateFilterFormState({
          selectedMinDepositRanges: selectedLabels,
        });

        const newState = handleApplyFilters();
        if (!newState) return;

        updateFiltersEvent({
          additional_attributes: {
            min_deposit: selectedLabels,
            term_length: newState.appliedFilters.selectedTermRanges,
          },
        });
      },
      scrollBackToMainBar ? 100 : 0,
    );
  };

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Minimum Deposit"
      options={minDepositOptions}
      selectedOptions={appliedFilters?.selectedMinDepositRanges || []}
      onChange={handleMinDepositChange}
      useStore={useOffersFilterStore}
      isFiltersInHeader={isFiltersInHeader}
    />
  );
};
